import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=1d7e1c33&scoped=true&"
import script from "./Document.vue?vue&type=script&lang=ts&"
export * from "./Document.vue?vue&type=script&lang=ts&"
import style0 from "./Document.vue?vue&type=style&index=0&id=1d7e1c33&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e1c33",
  null
  
)

export default component.exports